import { createRouter, createWebHistory, isNavigationFailure } from 'vue-router';
// import Home from './views/Home.vue';
import {PageName} from '@/common/core/common';
import {ClientAdapter} from '@/common/core/clientAdapter';
import {VueEx} from "@/common/core/VueEx";
// @ts-ignore
import gtag, { install } from 'ga-gtag';

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    {
      // 仮登録画面
      path: '/register',
      name: PageName.TMP_REGISTER,
      component: () => import(/* webpackChunkName: 'about' */ './views/TmpRegister.vue'),
      meta: {
        denyAuth: true,
        title: 'Temp Signup - 駅徒歩30秒の新宿最安レンタルスタジオインザハウス【inthehouse】'
      },
    },
    {
      // 仮登録メール送信完了画面
      path: '/sent_confirmation_mail',
      name: PageName.SENT_CONFIRMATION_MAIL,
      component: () => import(/* webpackChunkName: 'about' */ './views/SentRegistrationMail.vue'),
      meta: {
        denyAuth: true,
        title: 'Send - 駅徒歩30秒の新宿最安レンタルスタジオインザハウス【inthehouse】'
      },
    },
    {
      // 仮登録完了画面
      path: '/success_register',
      name: PageName.SUCCESS_TMP_REGISTER,
      component: () => import(/* webpackChunkName: 'about' */ './views/SuccessTmpRegister.vue'),
      meta: {
        denyAuth: true,
        title: 'Temp Regist - 駅徒歩30秒の新宿最安レンタルスタジオインザハウス【inthehouse】'
      },
    },
    {
      // ログイン画面
      path: '/login',
      name: PageName.LOGIN,
      component: () => import(/* webpackChunkName: 'about' */ './views/Login.vue'),
      meta: {
        denyAuth: true,
        title: 'Login - 駅徒歩30秒の新宿最安レンタルスタジオインザハウス【inthehouse】'
      },
    },
    {
      // 本登録画面
      path: '/update',
      name: PageName.UPDATE,
      component: () => import(/* webpackChunkName: 'about' */ './views/Register.vue'),
      meta: {
        requiresAuth: true,
        title: 'Signup - 駅徒歩30秒の新宿最安レンタルスタジオインザハウス【inthehouse】'
      },
    },
    {
      // 本登録内容確認画面
      path: '/update_confirmation',
      name: PageName.UPDATE_CONFIRMATION,
      component: () => import(/* webpackChunkName: 'about' */ './views/RegisterConfirmation.vue'),
      meta: {
        requiresAuth: true,
        title: 'Confirm - 駅徒歩30秒の新宿最安レンタルスタジオインザハウス【inthehouse】'
      },
    },
    {
      // システムエラー画面
      path: '/system_error',
      name: PageName.SYSTEM_ERROR,
      component: () => import(/* webpackChunkName: 'about' */ './views/SystemError.vue'),
      meta: {
        title: 'System Error - 駅徒歩30秒の新宿最安レンタルスタジオインザハウス【inthehouse】'
      },
    },
    {
      // マイページ画面
      path: '/mypage',
      name: PageName.MYPAGE,
      component: () => import(/* webpackChunkName: 'about' */ './views/Mypage.vue'),
      meta: {
        requiresAuth: true,
        title: 'My Page - 駅徒歩30秒の新宿最安レンタルスタジオインザハウス【inthehouse】'
      },
    },
    {
      // Page Not Found画面
      path: '/:pathMatch(.*)*',
      component: () => import(/* webpackChunkName: 'about' */ './views/404.vue'),
      meta: {
        title: 'Not Found - 駅徒歩30秒の新宿最安レンタルスタジオインザハウス【inthehouse】'
      },
    },
    {
      // スタジオ予約画面_空き検索
      path: '/studio_search',
      name: PageName.STUDIO_SEARCH,
      component: () => import(/* webpackChunkName: 'about' */ './views/StudioSearch.vue'),
      meta: {
        title: 'Studio Search - 駅徒歩30秒の新宿最安レンタルスタジオインザハウス【inthehouse】'
      },
    },
    {
      // スタジオ予約画面_一覧確認
      path: "/reservation_list",
      name: PageName.RESERVATION_LIST,
      component: () =>
        import(/* webpackChunkName: 'about' */ "./views/ReservationList.vue"),
      meta: {
        requiresAuth: true,
        title:
          "Reservation List - 駅徒歩30秒の新宿最安レンタルスタジオインザハウス【inthehouse】",
      },
    },
    {
      // スタジオ予約画面_予約詳細
      path: '/studio_detail',
      name: PageName.STUDIO_DETAIL,
      component: () => import(/* webpackChunkName: 'about' */ './views/StudioDetail.vue'),
      meta: {
        requiresAuth: true,
        title: 'Studio Detail - 駅徒歩30秒の新宿最安レンタルスタジオインザハウス【inthehouse】'
      },
    },
    {
      // スタジオ予約画面_内容確認
      path: '/studio_confirm',
      name: PageName.STUDIO_CONFIRM,
      component: () => import(/* webpackChunkName: 'about' */ './views/StudioConfirm.vue'),
      meta: {
        requiresAuth: true,
        title: 'Studio Confirm - 駅徒歩30秒の新宿最安レンタルスタジオインザハウス【inthehouse】'
      },
    },
    {
      // スタジオ予約画面_予約完了
      path: '/studio_complete',
      name: PageName.STUDIO_COMPLETE,
      component: () => import(/* webpackChunkName: 'about' */ './views/StudioComplete.vue'),
      meta: {
        requiresAuth: true,
        title: 'Studio Complete - 駅徒歩30秒の新宿最安レンタルスタジオインザハウス【inthehouse】'
      },
    },
    {
      // セッションタイムアウト画面
      path: '/session_timeout',
      name: PageName.SESSION_TIMEOUT,
      component: () => import(/* webpackChunkName: 'about' */ './views/SessionTimeout.vue'),
      meta: {
        title: 'Session Timeout - 駅徒歩30秒の新宿最安レンタルスタジオインザハウス【inthehouse】'
      },
    },
    {
      // パスワード再設定依頼画面
      path: '/password_reset_request',
      name: PageName.PASSWORD_RESET_REQUEST,
      component: () => import(/* webpackChunkName: 'about' */ './views/PasswordResetRequest.vue'),
      meta: {
        title: 'Password Reset Request - 駅徒歩30秒の新宿最安レンタルスタジオインザハウス【inthehouse】'
      },
    },
    {
      // パスワード再設定依頼完了画面
      path: '/password_reset_request_complete',
      name: PageName.PASSWORD_RESET_REQUEST_COMPLETE,
      component: () => import(/* webpackChunkName: 'about' */ './views/PasswordResetRequestComplete.vue'),
      meta: {
        title: 'Password Reset Request Complete - 駅徒歩30秒の新宿最安レンタルスタジオインザハウス【inthehouse】'
      },
    },
    {
      // パスワード再設定画面
      path: '/password_reset',
      name: PageName.PASSWORD_RESET,
      component: () => import(/* webpackChunkName: 'about' */ './views/PasswordReset.vue'),
      meta: {
        title: 'Password Reset - 駅徒歩30秒の新宿最安レンタルスタジオインザハウス【inthehouse】'
      },
    },
    {
      // パスワード再設定画面
      path: '/password_reset_complete',
      name: PageName.PASSWORD_RESET_COMPLETE,
      component: () => import(/* webpackChunkName: 'about' */ './views/PasswordResetComplete.vue'),
      meta: {
        title: 'Password Reset Complete - 駅徒歩30秒の新宿最安レンタルスタジオインザハウス【inthehouse】'
      },
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    return {left: 0, top: 0}
  },
});

const clientAdapter: ClientAdapter = new ClientAdapter();

const routing = function (to: any, from: any, next: any) {
  if (to.matched.some((record: any) => record.meta.requiresAuth)) {
    clientAdapter.getCurrentUserInfo().then((res: { memberId: string, userName: string, status: number }) => {
      VueEx.memberId = res.memberId;
      VueEx.userName = res.userName;
      VueEx.status = res.status;
      next();
    }).catch((err) => {
      // next({ path: '/login' });
      next({path: PageName.LOGIN, query: {redirect: to.fullPath, from: from.path}});
    });
  } else if (to.matched.some((record: any) => record.meta.denyAuth)) {
    if (from.path === PageName.STUDIO_DETAIL) {
      next({path: PageName.STUDIO_SEARCH});
    } else {
    clientAdapter.getCurrentUserInfo().then((res: { memberId: string, userName: string, status: number }) => {
      VueEx.memberId = res.memberId;
      VueEx.userName = res.userName;
      VueEx.status = res.status;
      next({path: PageName.MYPAGE});
    }).catch((err) => {
      next();
    })};
  } else {
    clientAdapter.getCurrentUserInfo().then((res: { memberId: string, userName: string, status: number }) => {
      VueEx.memberId = res.memberId;
      VueEx.userName = res.userName;
      VueEx.status = res.status;
      next();
    }).catch((err) => {
      next();
    })
  }
};

// >>>>>>>>> if checking local network delete this block
router.beforeEach((to, from, next) => {
  routing(to, from, next);
});

router.afterEach((to, from) => {
  install(process.env.VUE_APP_GA_TAG);
  gtag('config', process.env.VUE_APP_GA_TAG, {'page_path': to.path});
});
// <<<<<<<<< if checking local network delete this block

// Vue Router 4 rejects push() with NavigationFailure objects for cancelled/redirected navigation.
// Suppress these so they don't appear as unhandled promise rejections.
router.onError((error) => {
  if (isNavigationFailure(error)) return;
  console.error(error);
});

export default router;
